import { render, staticRenderFns } from "./StartingGuide.vue?vue&type=template&id=cfed1a60&scoped=true"
import script from "./StartingGuide.vue?vue&type=script&lang=js"
export * from "./StartingGuide.vue?vue&type=script&lang=js"
import style0 from "./StartingGuide.vue?vue&type=style&index=0&id=cfed1a60&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfed1a60",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/disk1/buildAgent/work/ffa2b6072150c7f8/vAnalyticsJS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cfed1a60')) {
      api.createRecord('cfed1a60', component.options)
    } else {
      api.reload('cfed1a60', component.options)
    }
    module.hot.accept("./StartingGuide.vue?vue&type=template&id=cfed1a60&scoped=true", function () {
      api.rerender('cfed1a60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/modules/admin/components/BuildingsSpaces/StartingGuide.vue"
export default component.exports